import { useEventStore } from "@/event";

const GENERIC_EVENTIUM_KEYS = new Set([
	"icon-eventium",
	"icon-christmas-eventium",
	"icon-easter-eventium",
	"icon-fishing-eventium",
	"icon-firefest-eventium",
	"icon-solarfair-eventium",
	"icon-hunting-eventium",
	"icon-halloween-eventium",
	"icon-pirates-eventium",
]);

/** Normalize seasonal-neutral keys to the currently active event sprite key. */
export function resolveSeasonalEventiumIconKey(key: string): string {
	if (!GENERIC_EVENTIUM_KEYS.has(key)) return key;
	const t = useEventStore().attributes.type;
	return `icon-${t}-eventium`;
}

export function eventiumIconCssClass(iconSize: number): string {
	return `icon-${useEventStore().attributes.type}-eventium-${iconSize}`;
}

export function eventChestKeyIconCssClass(iconSize: number): string {
	return `icon-${useEventStore().attributes.type}-chest-key-${iconSize}`;
}
